export default "__VITE_ASSET__CqWypm11__"